import { Injectable, EventEmitter } from '@angular/core';
import { QuestionnaireService } from '../questionnaire/questionnaire.service';
import { BuilderService } from '../builder/builder.service';

export class Suggestion {
  key: string;
  actionLabel: string;
}

@Injectable()
export class SuggestionService {

  active = false;
  active$ = new EventEmitter();

  suggestionKeyPaths = {
    'minQuestions': {
      key: 'minQuestions',
      actionLabel: 'searchMoreQuestions'
    },
    'maxQuestions': {
      key: 'maxQuestions',
      actionLabel: null
    },
    'minEssential': {
      key: 'minEssential',
      actionLabel: 'searchEssentialQuestions'
    },
    'minPerson': {
      key: 'minPerson',
      actionLabel: 'searchPersonQuestions'
    },
    'maxPerson': {
      key: 'maxPerson',
      actionLabel: null
    },
    'minJob': {
      key: 'minJob',
      actionLabel: 'searchJobQuestions'
    },
    'maxJob': {
      key: 'maxJob',
      actionLabel: null
    }
  };

  currentSuggestions: Suggestion[] = [];

  constructor(
    private q: QuestionnaireService,
    private builder: BuilderService
  ) {}

  show() {
    this.active = true;
    this.active$.emit(true);
  }

  hide() {
    this.active = false;
    this.active$.emit(false);
  }

  setSuggestions() {
    const questionnaire = this.builder.questionnaire;
    const questions = questionnaire.questions;
    const qMetrics = this.q.getCategoryMetrics(questionnaire);

    // Reset
    this.currentSuggestions = [];

    if (questions.length < 9) {
      this.currentSuggestions.push(this.suggestionKeyPaths['minQuestions']);
    }

    if (questions.length > 18) {
      this.currentSuggestions.push(this.suggestionKeyPaths['maxQuestions']);
    }

    if (qMetrics.essential < 5) {
      this.currentSuggestions.push(this.suggestionKeyPaths['minEssential']);
    }

    if (qMetrics.person < 4) {
      this.currentSuggestions.push(this.suggestionKeyPaths['minPerson']);
    }

    if (qMetrics.person > 7) {
      this.currentSuggestions.push(this.suggestionKeyPaths['maxPerson']);
    }

    if (qMetrics.role < 4) {
      this.currentSuggestions.push(this.suggestionKeyPaths['minJob']);
    }

    if (qMetrics.role > 7) {
      this.currentSuggestions.push(this.suggestionKeyPaths['maxJob']);
    }
  }
}
